export const is_valid_postcode = (input: string) => {
    // RegEx breakdown:
    // --- [ ^ ] = beginning of the string
    // --- [ () ] = group
    // --- --- [ [0-9]{4} ] = group of 4 digits
    // --- [ ()? ] = optional group
    // --- --- [ \s? ] = 1 optional whitespace char
    // --- [ ()? ] = optional group
    // --- --- [ [a-zA-Z]{2} ] = group of 2 chars
    // --- [ $ ] = end of the string
    let postcalCodeReq: RegExp = /^([0-9]{4})(\s?)?([a-zA-Z]{2})?$/;
    // RegEx breakdown: [
    // --- [ \s+ ] =  1 of more whitespace chars
    // --- [ /g ] = match all occurances
    return (postcalCodeReq.test(input.toLowerCase())) ? true : false;
}

export const is_valid_phone = (input: string) => {
    return true;
    // const libPhoneUtil = LibPhone.PhoneNumberUtil.getInstance();

    // try {
    //     const numberNL = libPhoneUtil.parseAndKeepRawInput(input, 'NL');
    //     const numberBE = libPhoneUtil.parseAndKeepRawInput(input, 'BE');

    //     if(libPhoneUtil.isPossibleNumber(numberNL)) return libPhoneUtil.isValidNumber(numberNL)
    //     if(libPhoneUtil.isPossibleNumber(numberBE)) return libPhoneUtil.isValidNumber(numberBE)
    //     return input.length > 5
    // }
    // catch (e) {
    //     return false;
    // }
}

export const is_valid_email = (input: string) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input)
}

export const is_valid_date = (input: string) => {
    // RegEx breakdown > https://regexr.com/3fe3s > We switched it to DD-MM-YYYY below
    let dateReq: RegExp = /([0-2]\d{1}|3[0-1])\-(0\d{1}|1[0-2])\-(19|20)\d{2}/
    return (dateReq.test(input)) ? true : false;
}